import ReactGA from 'react-ga';

let hasInit = false;

const googleAnalyticsTrackingId = process.env.GA_TRACKING_ID;

const dimensionMapping = {
  tenantId: process.env.GA_DIMENSION_TENANT_ID || 'dimension1',
  tenantSlug: process.env.GA_DIMENSION_TENANT_SLUG || 'dimension2',
  userType: process.env.GA_DIMENSION_USER_TYPE || 'dimension3',
  userId: process.env.GA_DIMENSION_USER_ID || 'dimension4',
};

const ga = {
  init: () => {
    if (googleAnalyticsTrackingId && !hasInit) {
      ReactGA.initialize(googleAnalyticsTrackingId);
      hasInit = true;
    }
  },
  config: (config) => {
    const { participantId, tenantId, slug } = config;

    if (googleAnalyticsTrackingId) {
      ReactGA.set({
        [dimensionMapping.tenantId]: tenantId,
        [dimensionMapping.tenantSlug]: slug,
        [dimensionMapping.userType]: participantId && 'participant',
        [dimensionMapping.userId]: participantId,
      });
    }
  },
  pageView: (path) => {
    if (googleAnalyticsTrackingId) {
      ReactGA.pageview(path);
    }
  },
  trackEvent: (category, action, label, value) => {
    label = label || action;

    if (googleAnalyticsTrackingId) {
      ReactGA.event({
        category,
        action,
        label,
        value,
      });
    }
  }
};

export default ga;



// WEBPACK FOOTER //
// src/tracking/ga.js